import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../../shared/services/config.service';
import { UserService } from '../../../../shared/services/user.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class TimeService {

  //#976 BEA 2021-01-08 to force reading from localstorage each (and every) time
  private get httpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-time-key',
        'SessionId': this.userService.sessionId
      })
    };
  }


  constructor(private http: HttpClient, private configService: ConfigService, private userService: UserService) {

  }

  getStatuses(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/core/GetStatuses", this.httpOptions);
  }

  getStatus(id: any): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/core/GetStatus/" + id, this.httpOptions);
  }

  getActiveProjectActivites(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + `/api/project/GetActiveProjectActivities?companyId=${this.userService.companyId}`, this.httpOptions);
  }

  getCustomers(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/core/GetCustomers", this.httpOptions);
  }

  getCustomer(id: any): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/core/GetCustomer/" + id, this.httpOptions);
  }

  getVMTimeSalaryApprovalSearch(): Observable<any> {

    return this.http.get<any>(this.configService.config.timeUrl + `/api/timesalary/GetVMTimeSalaryApprovalSearch?companyId=${this.userService.companyId}&employeeId=${this.userService.account.EmployeeId}`, this.httpOptions);
  }

  getBySearch(fromSearchDate: any, toSearchDate: any, statusIds: number[], categoryIds: number[], departmentIds: string[], isSupervisor: boolean): Observable<any> {


    // Prepare status querystring parameter(s)
    let selectedStatuses = "";
    statusIds.forEach(statusId => {

      selectedStatuses += "statusIds=" + statusId;
      if (statusId != statusIds[statusIds.length - 1]) {
        selectedStatuses += "&";
      }
    });

    let selectedCategories = "";
    categoryIds.forEach(categoryId => {

      selectedCategories += "categoryIds=" + categoryId;
      if (categoryId != categoryIds[categoryIds.length - 1]) {
        selectedCategories += "&";
      }
    });

    // Prepare department querystring parameter(s)
    let selectedDepartments = "";
    departmentIds.forEach(departmentId => {
      selectedDepartments += "departmentIds=" + departmentId;
      if (departmentId != departmentIds[departmentIds.length - 1]) {
        selectedDepartments += "&";
      }
    });
    return this.http.get<any>(this.configService.config.timeUrl + `/api/timesalary/GetTimeSalaryEmployeeByWeekList?companyId=${this.userService.companyId}&from=${fromSearchDate}&to=${toSearchDate}&${selectedStatuses}&${selectedCategories}&${selectedDepartments}&bIsSupervisor=${isSupervisor}`, this.httpOptions);
  }


  getSalaryApprovalBySearchCategoryStatusPairs(viewModel: any): Observable<any> {

    viewModel.CompanyId = this.userService.companyId;
    return this.http.post<any>(this.configService.config.timeUrl + `/api/timesalary/GetTimeSalaryEmployeeByWeekListCategoryStatusCombos`, viewModel, this.httpOptions);
  }

  getTimeSalariesByCategoryStatusPairsWithinPeriod(
    employeeIds: number[],
    fromDate: any,
    toDate: any,
    categoryStatusCombos: any[],
    departmentIds: string[],
    projectIds: number[],
    isSupervisor: boolean,
    selectedSupervisorId: number,
    portalTemplateId?: number,
    showAll: Boolean = true,
    hasReadAllPermission?: boolean,
    lastUpdateDate?: any): Observable<any> {

    const request = {
      FromDate: moment.utc(fromDate, "DD.MM.YYYY").format("MM-DD-YYYY"),
      ToDate: moment.utc(toDate, "DD.MM.YYYY").format("MM-DD-YYYY"),
      CompanyId: this.userService.companyId,
      EmployeeId: this.userService.account.EmployeeId,
      IsSupervisor: isSupervisor,
      SupervisorId: selectedSupervisorId,
      EmployeeIds: employeeIds,
      DepartmentIds: departmentIds,
      CategoryStatusCombos: categoryStatusCombos,
      ProjectIds: projectIds, 
      HasReadAllPermission: hasReadAllPermission,
      LastUpdateDate: lastUpdateDate
    };

    return this.http.post<any>(`${this.configService.config.timeUrl}/api/timesalaries/gettimesalariesbycategorystatuspairswithinperiod?portalTemplateId=${portalTemplateId}&showAll=${showAll}`, request, this.httpOptions);
  }

  getTimeSalariesByProjectAndCategoryStatusPairsWithinPeriod(
    employeeIds: number[],
    fromDate: any,
    toDate: any,
    categoryStatusCombos: any[],
    departmentIds: string[],
    projectIds: number[],
    isSupervisor: boolean,
    selectedSupervisorId: number,
    projectId: number,
    portalTemplateId?: number,
    showAll: boolean = true,
    lastUpdateDate?: any): Observable<any> {

    const request = {
      FromDate: moment.utc(fromDate, "DD.MM.YYYY").format("MM-DD-YYYY"),
      ToDate: moment.utc(toDate, "DD.MM.YYYY").format("MM-DD-YYYY"),
      CompanyId: this.userService.companyId,
      EmployeeId: this.userService.account.EmployeeId,
      IsSupervisor: isSupervisor,
      SupervisorId: selectedSupervisorId,
      EmployeeIds: employeeIds,
      DepartmentIds: departmentIds,
      CategoryStatusCombos: categoryStatusCombos,
      ProjectIds: projectIds,
      LastUpdateDate: lastUpdateDate
    };
    return this.http.post<any>(`${this.configService.config.timeUrl}/api/timesalaries/gettimesalariesbyprojectandcategorystatuspairswithinperiod?projectid=${projectId}&portalTemplateId=${portalTemplateId}&showAll=${showAll}`, request, this.httpOptions);
  }

  getTimeSalariesByProjectWithChildrenAndCategoryStatusPairsWithinPeriod(
    employeeIds: number[],
    fromDate: any,
    toDate: any,
    categoryStatusCombos: any[],
    departmentIds: string[],
    projectIds: number[],
    isSupervisor: boolean,
    selectedSupervisorId: number,
    projectId: number,
    portalTemplateId?: number,
    showAll: boolean = true,
    lastUpdateDate?: any): Observable<any> {

    const request = {
      FromDate: moment.utc(fromDate, "DD.MM.YYYY").format("MM-DD-YYYY"),
      ToDate: moment.utc(toDate, "DD.MM.YYYY").format("MM-DD-YYYY"),
      CompanyId: this.userService.companyId,
      EmployeeId: this.userService.account.EmployeeId,
      IsSupervisor: isSupervisor,
      SupervisorId: selectedSupervisorId,
      EmployeeIds: employeeIds,
      DepartmentIds: departmentIds,
      CategoryStatusCombos: categoryStatusCombos,
      ProjectIds: projectIds,
      LastUpdateDate: lastUpdateDate
    };
    return this.http.post<any>(`${this.configService.config.timeUrl}/api/timesalaries/gettimesalariesbyprojectwithchildrenandcategorystatuspairswithinperiod?projectid=${projectId}&portalTemplateId=${portalTemplateId}&showAll=${showAll}`, request, this.httpOptions);
  }

  getTimeSalariesWithinPeriod(employeeIds: number[], fromDate: any, toDate: any, statusIds: number[], categoryIds: number[], departmentIds: string[], isSupervisor: boolean, selectedSupervisorId: number, portalTemplateId?: number): Observable<any> {
    const request = {
      FromDate: moment.utc(fromDate, "DD.MM.YYYY").format("MM-DD-YYYY"),
      ToDate: moment.utc(toDate, "DD.MM.YYYY").format("MM-DD-YYYY"),
      CompanyId: this.userService.companyId,
      EmployeeId: this.userService.account.EmployeeId,
      IsSupervisor: isSupervisor,
      SupervisorId: selectedSupervisorId,
      EmployeeIds: employeeIds,
      DepartmentIds: departmentIds,
      StatusIds: statusIds,
      CategoryIds: categoryIds
    };

    return this.http.post<any>(`${this.configService.config.timeUrl}/api/timesalaries/gettimesalarieswithinperiod?portalTemplateId=${portalTemplateId}`, request, this.httpOptions);
  }

  getTimeSalariesByProjectWithinPeriod(employeeIds: number[], fromDate: any, toDate: any, statusIds: number[], categoryIds: number[], departmentIds: string[], isSupervisor: boolean, selectedSupervisorId: number, projectId: number, portalTemplateId?: number): Observable<any> {
    const request = {
      FromDate: moment.utc(fromDate, "DD.MM.YYYY").format("MM-DD-YYYY"),
      ToDate: moment.utc(toDate, "DD.MM.YYYY").format("MM-DD-YYYY"),
      CompanyId: this.userService.companyId,
      EmployeeId: this.userService.account.EmployeeId,
      IsSupervisor: isSupervisor,
      SupervisorId: selectedSupervisorId,
      EmployeeIds: employeeIds,
      DepartmentIds: departmentIds,
      StatusIds: statusIds,
      CategoryIds: categoryIds
    };

    return this.http.post<any>(`${this.configService.config.timeUrl}/api/timesalaries/gettimesalariesbyprojectwithinperiod?projectid=${projectId}&portalTemplateId=${portalTemplateId}`, request, this.httpOptions);
  }

  getTimes(employeeIds: number[], fromSearchDate: any, toSearchDate: any, statusIds: number[], categoryIds: number[], departmentIds: string[], isSupervisor: boolean, selectedSupervisorId: number): Observable<any> {


    // Prepare employees querystring parameter(s)
    let selectedEmployees = "";
    employeeIds.forEach(employeeId => {
      selectedEmployees += "employeeIds=" + employeeId;
      if (employeeId != employeeIds[employeeIds.length - 1]) {
        selectedEmployees += "&";
      }
    });

    // Prepare status querystring parameter(s)
    let selectedStatuses = "";
    statusIds.forEach(statusId => {
      selectedStatuses += "statusIds=" + statusId;
      if (statusId != statusIds[statusIds.length - 1]) {
        selectedStatuses += "&";
      }
    });

    let selectedCategories = "";
    categoryIds.forEach(categoryId => {
      selectedCategories += "categoryIds=" + categoryId;
      if (categoryId != categoryIds[categoryIds.length - 1]) {
        selectedCategories += "&";
      }
    });

    // Prepare department querystring parameter(s)
    let selectedDepartments = "";
    departmentIds.forEach(departmentId => {
      selectedDepartments += "departmentIds=" + departmentId;
      if (departmentId != departmentIds[departmentIds.length - 1]) {
        selectedDepartments += "&";
      }
    });
    return this.http.get<any>(this.configService.config.timeUrl + `/api/timesalary/GetTimeSalaryTimesByEmployeeList?companyId=${this.userService.companyId}&${selectedEmployees}&from=${fromSearchDate}&to=${toSearchDate}&${selectedStatuses}&${selectedCategories}&${selectedDepartments}&bIsSupervisor=${isSupervisor}&selectedSupervisorId=${selectedSupervisorId}`, this.httpOptions);
  }

  getTimesAvailableToApprove(viewModel: any): Observable<any> {

    viewModel.CompanyId = this.userService.companyId;
    return this.http.post<any>(this.configService.config.timeUrl + `/api/timesalary/GetTimeSalaryTimesByEmployeeListCategoryStatusPair`, viewModel, this.httpOptions);
  }

  getTransportFromTimeId(timeId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + `/api/timesalary/GetTransportFromTimeId?timeId=${timeId}`, this.httpOptions);
  }

  getWeekOverviewByTimeId(timeId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + `/api/getweekoverviewbytime/getweekoverview?id=${timeId}`, this.httpOptions);
  }

  getEmployeePortalWeekOverviewByTimeId(timeId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + `/api/getweekoverviewbytime/getweekoverviewforemployeeportal?id=${timeId}`, this.httpOptions);
  }

  getTransportFromAdditionId(additionId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + `/api/timesalary/GetTransportFromAdditionId?additionId=${additionId}`, this.httpOptions);
  }

  getTransportFromExpenseId(expenseId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + `/api/timesalary/GetTransportFromExpenseId?expenseId=${expenseId}`, this.httpOptions);
  }

  getTimeTypes(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/time/GetTimeTypes", this.httpOptions);
  }

  getEquipment(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/timesalary/GetEquipment", this.httpOptions);
  }

  getEquipmentByTransportCollection(transportCollectionId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + '/api/transport/GetTransportEquipmentByTransportCollection?transportCollectionId=' + transportCollectionId, this.httpOptions);
  }

  getTransportEquipmentByCarrier(id: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + '/api/gettransportequipment/getbycarrier?id=' + id, this.httpOptions);
  }

  getTransportEquipmentByCarrierEmployeeDate(carrierId: number, employeeId: number, date: Date): Observable<any> {
    return this.http.get<any>(`${this.configService.config.timeUrl}/api/gettransportequipment/GetByProjectEmployeeDate?carrierId=${carrierId}&employeeId=${employeeId}&date=${date}`, this.httpOptions);
  }

  updateTransportCollection(transportCollectionId: number, date: Date, employeeId: number, primaryprojectId: number, secondaryProjectId: number, customRef: string, comment: string) {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/transport/TransportCollectionUpdate?transportCollectionId=' + transportCollectionId + '&date=' + date + '&employeeId=' + employeeId + '&primaryprojectId=' + primaryprojectId + '&secondaryProjectId=' + secondaryProjectId + '&customRef=' + customRef + '&comment=' + comment, [], this.httpOptions);
  }

  insertEquipment(equipment: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/transport/TransportCollectionAddTransportEquipment', equipment, this.httpOptions);
  }

  updateEquipment(keyCarrierId: number, keyEquipmentId: number, equipmentId: number, isMainEquipment: boolean, loadedEquipment: boolean, seconds: number): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/transport/TransportCollectionUpdateTransportEquipment?keyCarrierId=' + keyCarrierId + '&keyEquipmentId=' + keyEquipmentId + '&newEquipmentId=' + equipmentId + '&newIsMainEquipment=' + isMainEquipment + '&newLoadedEquipment=' + loadedEquipment + '&seconds=' + seconds, [], this.httpOptions);
  }

  deleteEquipmentByEquipmentIds(carrierId: number, ids: number[]): Observable<any> {
    let equipmentIds = "";
    ids.forEach(equipmentId => {

      equipmentIds += "equipmentIds=" + equipmentId;
      if (equipmentId != ids[ids.length - 1]) {
        equipmentIds += "&";
      }
    });

    return this.http.post<any>(this.configService.config.timeUrl + `/api/transport/TransportEquipmentDelete?carrierId=${carrierId}&${equipmentIds}`, [], this.httpOptions);
  }

  deleteTransportEquipmentByCarrierAndEquipment(carrierId: number, equipmentIds: number[]): Observable<any> {
    const options = { headers: this.httpOptions.headers, body: { CarrierId: carrierId, EquipmentIds: equipmentIds } };

    return this.http.delete<any>(this.configService.config.timeUrl + `/api/deletetransportequipment/delete`, options);
  }

  getAdditionTypes(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/timesalary/GetAdditionTypes", this.httpOptions);
  }

  getAdditionsByTransportCollection(transportCollectionId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + '/api/addition/GetAdditionsByTransportCollection?transportCollectionId=' + transportCollectionId, this.httpOptions);
  }

  insertAddition(addition: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/addition/TimeSalaryApprovalAddAddition', addition, this.httpOptions);
  }

  updateAddition(addition: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/addition/TimeSalaryApprovalUpdateAddition', addition, this.httpOptions);
  }

  deleteAdditionByAdditionIds(ids: number[]): Observable<any> {

    let additionIds = "";
    ids.forEach(additionId => {

      additionIds += "additionIds=" + additionId;
      if (additionId != ids[ids.length - 1]) {
        additionIds += "&";
      }
    });


    return this.http.post<any>(this.configService.config.timeUrl + `/api/addition/TimeSalaryApprovalDeleteByAdditionIds?${additionIds}`, [], this.httpOptions);
  }

  deleteAddition(additionId: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/addition/TimeSalaryApprovalDeleteAddition?additionid=' + additionId, [], this.httpOptions);
  }

  confirmAdditionByAdditionIds(ids: number[]): Observable<any> {

    let additionIds = "";
    ids.forEach(additionId => {

      additionIds += "additionIds=" + additionId;
      if (additionId != ids[ids.length - 1]) {
        additionIds += "&";
      }
    });

    return this.http.post<any>(this.configService.config.timeUrl + `/api/addition/TimeSalaryApprovalConfirmByAdditionIds?${additionIds}`, [], this.httpOptions);
  }

  approveAdditionByAdditionIds(ids: number[], approvalFunction: number): Observable<any> {

    let additionIds = "";
    ids.forEach(additionId => {

      additionIds += "additionIds=" + additionId;
      if (additionId != ids[ids.length - 1]) {
        additionIds += "&";
      }
    });

    return this.http.post<any>(this.configService.config.timeUrl + `/api/addition/TimeSalaryApprovalApproveByAdditionIds?${additionIds}&approvalFunction=${approvalFunction}`, [], this.httpOptions);
  }

  resetAdditionByAdditionIds(ids: number[], statusId: number, approvalFunction: number): Observable<any> {

    let additionIds = "";
    ids.forEach(additionId => {

      additionIds += "additionIds=" + additionId;
      if (additionId != ids[ids.length - 1]) {
        additionIds += "&";
      }
    });

    return this.http.post<any>(this.configService.config.timeUrl + `/api/addition/TimeSalaryApprovalResetByAdditionIds?${additionIds}&statusId=${statusId}&approvalFunction=${approvalFunction}`, [], this.httpOptions);
  }

  resetExpenseByExpenseIds(ids: number[], statusId: number, approvalFunction: number): Observable<any> {

    let expenseIds = "";
    ids.forEach(expenseId => {

      expenseIds += "expenseIds=" + expenseId;
      if (expenseId != ids[ids.length - 1]) {
        expenseIds += "&";
      }
    });

    return this.http.post<any>(this.configService.config.timeUrl + `/api/expense/TimeSalaryApprovalResetByExpenseIds?${expenseIds}&statusId=${statusId}&approvalFunction=${approvalFunction}`, [], this.httpOptions);
  }

  getExpenseTypes(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/timesalary/GetExpenseTypes", this.httpOptions);
  }

  getExpensesByTransportCollection(transportCollectionId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + '/api/expense/GetExpensesByTransportCollection?transportCollectionId=' + transportCollectionId, this.httpOptions);
  }

  insertExpense(addition: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/expense/TimeSalaryApprovalAddExpense', addition, this.httpOptions);
  }

  updateExpense(addition: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/expense/TimeSalaryApprovalUpdateExpense', addition, this.httpOptions);
  }

  deleteExpenseByExpenseIds(ids: number[]): Observable<any> {

    let expenseIds = "";
    ids.forEach(expenseId => {

      expenseIds += "expenseIds=" + expenseId;
      if (expenseId != ids[ids.length - 1]) {
        expenseIds += "&";
      }
    });

    return this.http.post<any>(this.configService.config.timeUrl + `/api/expense/TimeSalaryApprovalDeleteByExpenseIds?${expenseIds}`, [], this.httpOptions);
  }

  confirmExpenseByExpenseIds(ids: number[]): Observable<any> {

    let expenseIds = "";
    ids.forEach(expenseId => {

      expenseIds += "expenseIds=" + expenseId;
      if (expenseId != ids[ids.length - 1]) {
        expenseIds += "&";
      }
    });

    return this.http.post<any>(this.configService.config.timeUrl + `/api/expense/TimeSalaryApprovalConfirmByExpenseIds?${expenseIds}`, [], this.httpOptions);
  }

  approveExpenseByExpenseIds(ids: number[], approvalFunction: number): Observable<any> {

    let expenseIds = "";
    ids.forEach(expenseId => {

      expenseIds += "expenseIds=" + expenseId;
      if (expenseId != ids[ids.length - 1]) {
        expenseIds += "&";
      }
    });

    return this.http.post<any>(this.configService.config.timeUrl + `/api/expense/TimeSalaryApprovalApproveByExpenseIds?${expenseIds}&approvalFunction=${approvalFunction}`, [], this.httpOptions);
  }

  getTransportArticles(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/transport/GetTransportArticles", this.httpOptions);
  }

  getTransportArticlesByTransportCollection(transportCollectionId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + '/api/transport/GetTransportArticlesByTransportCollection?transportCollectionId=' + transportCollectionId, this.httpOptions);
  }

  insertTransportArticle(transportCarriedArticle: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/transport/TransportCollectionAddTransportCarriedArticle', transportCarriedArticle, this.httpOptions);
  }

  updateTransportArticle(keyCarrierId: number, keyTransportArticleId: number, transportArticleId: number, quantity: number): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/transport/TransportCollectionUpdateTransportArticle?keyCarrierId=' + keyCarrierId + '&keyTransportArticleId=' + keyTransportArticleId + '&newTransportArticleId=' + transportArticleId + '&newQuantity=' + quantity, [], this.httpOptions);
  }

  deleteTransportArticleByTransportArticleIds(carrierId: number, ids: number[]): Observable<any> {

    let tcaIds = "";
    ids.forEach(tcaId => {

      tcaIds += "tcaIds=" + tcaId;
      if (tcaId != ids[ids.length - 1]) {
        tcaIds += "&";
      }
    });

    return this.http.post<any>(this.configService.config.timeUrl + `/api/transport/TransportCarriedArticleDelete?carrierId=${carrierId}&${tcaIds}`, [], this.httpOptions);
  }

  getProjectsBySearchText(searchText: string): Observable<any> {
    let requestOptions = {
      params: new HttpParams()
        .append('searchtext', searchText),
      headers: this.httpOptions.headers,
    }
    return this.http.get<any>(this.configService.config.timeUrl + '/api/project/GetBySearchText', requestOptions);
  }

  getProjectsByCustomerId(customerId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + '/api/project/GetByCustomerId?customerId=' + customerId, this.httpOptions);
  }

  getProjectById(id: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/project/Get/" + id, this.httpOptions);
  }

  getProjectSearchBoxById(id: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/project/GetProjectSelectBoxById/" + id, this.httpOptions);
  }

  getTimesByTransportCollection(transportCollectionId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + '/api/time/GetTimesByTransportCollection?transportCollectionId=' + transportCollectionId, this.httpOptions);
  }

  insertTimeSalaryTime(time: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/timesalary/TimeSalaryApprovalAddTime', time, this.httpOptions);
  }

  insertMultipleTimeSalaryTime(timesalaries: any[]): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/timesalary/TimeSalaryApprovalAddMultipleTimes', timesalaries, this.httpOptions);
  }

  updateTimeSalaryTime(time: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/timesalary/TimeSalaryApprovalUpdateTime', time, this.httpOptions);
  }

  updateMultipleTimeSalaryTime(timesalaries: any[]): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/timesalary/TimeSalaryApprovalUpdateMultipleTimes', timesalaries, this.httpOptions);
  }

  saveMultipleTimeSalaryTimes(timeSalariesToAdd: any[], timeSalariesToUpdate: any[], timeSalariesToUpdateWithOriginalPKValues: any[]): Observable<any> {
    const request = {
      TimeSalariesToAdd: timeSalariesToAdd,
      TimeSalariesToUpdate: timeSalariesToUpdate,
      TimeSalariesToUpdateWithOriginalPKValues: timeSalariesToUpdateWithOriginalPKValues
    };

    return this.http.post<any>(this.configService.config.timeUrl + '/api/timesalaries/SaveTimeSalaries', request, this.httpOptions);
  }

  saveQuickEntryTimes(quickEntries: any[]): Observable<any> {
    const request = { QuickEntryTimeSalaries: quickEntries };

    return this.http.post<any>(this.configService.config.timeUrl + '/api/timesalaries/SaveQuickEntryTimeSalaries', request, this.httpOptions);
  }

  deleteTimeSalaries(timeFilters: any[]): Observable<any> {
    const request = { TimeFilters: timeFilters };

    return this.http.post<any>(this.configService.config.timeUrl + '/api/timesalaries/deletetimesalaries', request, this.httpOptions);
  }

  deleteTimeSalaryTime(timeId: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + '/api/timesalary/TimeSalaryApprovalDeleteTime?timeId=' + timeId, [], this.httpOptions);
  }

  isTimeTypeAllowed(employeeId: number, timeTypeId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + `/api/timesalary/IsTimeTypeAllowed?employeeId=${employeeId}&timeTypeId=${timeTypeId}`, this.httpOptions);
  }

  deleteTimeByTimeIds(ids: number[]): Observable<any> {

    let timeIds = "";
    ids.forEach(timeId => {

      timeIds += "timeIds=" + timeId;
      if (timeId != ids[ids.length - 1]) {
        timeIds += "&";
      }
    });


    return this.http.post<any>(this.configService.config.timeUrl + `/api/time/TimeDeleteByTimeIds?${timeIds}`, [], this.httpOptions);
  }

  confirmTimeSalaryTimeIds(ids: number[]): Observable<any> {

    let timeIds = "";
    ids.forEach(timeId => {

      timeIds += "timeIds=" + timeId;
      if (timeId != ids[ids.length - 1]) {
        timeIds += "&";
      }
    });


    return this.http.post<any>(this.configService.config.timeUrl + `/api/timesalary/TimeSalaryApprovalConfirmByTimeIds?${timeIds}`, [], this.httpOptions);
  }

  approveTimeSalaries(timeFilters: any, approvalFunction: number): Observable<any> {
    const request = { ApprovalFunction: approvalFunction, TimeFilters: timeFilters };

    return this.http.post<any>(this.configService.config.timeUrl + `/api/timesalary/TimeSalaryApprovalApproveByTimeIds`, request, this.httpOptions);
  }

  resetTimeSalaryTimeIds(timeFilters: any, approvalFunction: number, statusId: number): Observable<any> {
    const request = { ApprovalFunction: approvalFunction, TimeFilters: timeFilters };

    return this.http.post<any>(this.configService.config.timeUrl + `/api/timesalary/TimeSalaryApprovalResetByTimeIds?statusId=${statusId}`, request, this.httpOptions);
  }

  readySalaryTimeSalaryTimeIds(ids: number[]): Observable<any> {

    let timeIds = "";
    ids.forEach(timeId => {

      timeIds += "timeIds=" + timeId;
      if (timeId != ids[ids.length - 1]) {
        timeIds += "&";
      }
    });

    return this.http.post<any>(this.configService.config.timeUrl + `/api/timesalary/TimeSalaryApprovalReadySalaryByTimeIds?${timeIds}`, [], this.httpOptions);
  }

  confirmTimeSalaryEmployeeIds(employeeIds: number[], fromSearchDate: any, toSearchDate: any, statusIds: string[], departmentIds: string[], isSupervisor: boolean, selectedSupervisorId: number, projectIds: number[]): Observable<any> {

    // Prepare status querystring parameter(s)
    let selectedEmployees = "";
    employeeIds.forEach(employeeId => {

      selectedEmployees += "employeeIds=" + employeeId;
      if (employeeId != employeeIds[employeeIds.length - 1]) {
        selectedEmployees += "&";
      }
    });

    let selectedStatuses = "";
    statusIds.forEach(statusId => {

      selectedStatuses += "statusIds=" + statusId;
      if (statusId != statusIds[statusIds.length - 1]) {
        selectedStatuses += "&";
      }
    });

    let selectedDepartments = "";
    departmentIds.forEach(departmentId => {
      selectedDepartments += "departmentIds=" + departmentId;
      if (departmentId != departmentIds[departmentIds.length - 1]) {
        selectedDepartments += "&";
      }
    });

    let selectedProjectIds = "";
    projectIds.forEach(projectId => {
      selectedProjectIds += "projectIds=" + projectId;
      if (projectId != projectIds[projectIds.length - 1]) {
        selectedProjectIds += "&";
      }
    });
    return this.http.post<any>(this.configService.config.timeUrl + `/api/timesalary/TimeSalaryApprovalConfirmByEmployeeIds?companyId=${this.userService.companyId}&userEmployeeId=${this.userService.userId}&${selectedEmployees}&from=${fromSearchDate}&to=${toSearchDate}&${selectedStatuses}&${selectedDepartments}&${selectedProjectIds}&bIsSupervisor=${isSupervisor}&selectedSupervisorId=${selectedSupervisorId}`, [], this.httpOptions);
  }

  readySalaryTimeSalaryEmployeeIds(employeeIds: number[], fromSearchDate: any, toSearchDate: any, statusIds: string[], departmentIds: string[], isSupervisor: boolean, selectedSupervisorId: number): Observable<any> {

    // Prepare status querystring parameter(s)
    let selectedEmployees = "";
    employeeIds.forEach(employeeId => {

      selectedEmployees += "employeeIds=" + employeeId;
      if (employeeId != employeeIds[employeeIds.length - 1]) {
        selectedEmployees += "&";
      }
    });

    let selectedStatuses = "";
    statusIds.forEach(statusId => {

      selectedStatuses += "statusIds=" + statusId;
      if (statusId != statusIds[statusIds.length - 1]) {
        selectedStatuses += "&";
      }
    });

    let selectedDepartments = "";
    departmentIds.forEach(departmentId => {
      selectedDepartments += "departmentIds=" + departmentId;
      if (departmentId != departmentIds[departmentIds.length - 1]) {
        selectedDepartments += "&";
      }
    });
    return this.http.post<any>(this.configService.config.timeUrl + `/api/timesalary/TimeSalaryApprovalReadySalaryByEmployeeIds?companyId=${this.userService.companyId}&userEmployeeId=${this.userService.userId}&${selectedEmployees}&from=${fromSearchDate}&to=${toSearchDate}&${selectedStatuses}&${selectedDepartments}&bIsSupervisor=${isSupervisor}&selectedSupervisorId=${selectedSupervisorId}`, [], this.httpOptions);
  }

  /*SalaryTransfer*/
  getVMSalaryTransferSearch(): Observable<any> {

    return this.http.get<any>(this.configService.config.timeUrl + `/api/salarytransfer/GetVMSalaryTransferSearch?companyId=${this.userService.companyId}`, this.httpOptions);
  }

  getVMSalaryTransfer(toDate: string, departmentIds: string[]): Observable<any> {

    let selectedDepartments = "departmentIds=";
    departmentIds.forEach(departmentId => {
      selectedDepartments += departmentId;
      if (departmentId != departmentIds[departmentIds.length - 1]) {
        selectedDepartments += ",";
      }
    });

    return this.http.get<any>(this.configService.config.timeUrl + `/api/salarytransfer/GetVMTimesConfirm?toDate=${toDate}&${selectedDepartments}`, this.httpOptions);
  }

  executeCreateSalary(rec: any): Observable<any> {

    return this.http.post<any>(this.configService.config.timeUrl + `/api/salarytransfer/ExecuteCreateSalary`, rec, this.httpOptions);

  }

  getProductionSites(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/time/GetProductionSites", this.httpOptions);
  }

  getDepartments(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/core/GetDepartments", this.httpOptions);
  }

  getOperationNames(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/time/GetOperationNames", this.httpOptions);
  }

  getEmployees(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/core/GetEmployees", this.httpOptions);
  }

  getOverview(viewModel: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + "/api/time/GetOverview", viewModel, this.httpOptions);
  }

  getOverviewDetail(viewModel: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + "/api/time/GetOverviewDetail", viewModel, this.httpOptions);
  }

  getOverviewDetailDate(viewModel: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + "/api/time/GetOverviewDetailDate", viewModel, this.httpOptions);
  }

  getEmployeeTimesByWeek(employeeId: any, date: any): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/time/GetEmployeeTimesByWeek?employeeId=" + employeeId + "&date=" + date, this.httpOptions);
  }

  getEmployeeTimesByProject(employeeId: any, from: any, to: any): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/time/GetEmployeeTimesByProject?employeeId=" + employeeId + "&from=" + from + "&to=" + to, this.httpOptions);
  }

  getEmployeeBalanceOverview(): Observable<any> {
    return this.http.get<any>(this.configService.config.timeUrl + "/api/balance/GetEmployeeBalanceOverview", this.httpOptions);
  }

  getTimeReport(viewModel: any): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + "/api/time/GetTimeReport", viewModel, this.httpOptions);
  }

  copyAndSaveTimeSalaries(ids: number[]): Observable<any> {
    return this.http.post<any>(this.configService.config.timeUrl + `/api/timesalaries/CopyAndSaveTimeSalaries`, ids, this.httpOptions);
  }

}
